import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();
    
    // 🚨 强制禁用手风琴的焦点能力 🚨
    this.#disableFocusCompletely();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * 🚨 强制禁用手风琴的焦点能力 - 防止PhotoSwipe关闭后自动滚动 🚨
   */
  #disableFocusCompletely() {
    try {
      
      // 5. 移除手风琴内所有子元素的焦点能力
      // const focusableElements = this.querySelectorAll('*[tabindex]:not([tabindex="-1"])');
      // focusableElements.forEach(el => {
      //   el.setAttribute('tabindex', '-1');
      // });
      
      // 6. 监听焦点事件，防止手风琴获得焦点
      this.addEventListener('focus', (e) => {
        const target = e.target;
    
    // 如果焦点在可输入元素上，放行
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT' || target.isContentEditable)) {
      return;
    }

    // 阻止手风琴自身获得焦点
    e.preventDefault();
    e.stopPropagation();

    if (target && target instanceof HTMLElement) {
      target.blur();
    }
    document.body.focus();
  }, { capture: true });
      
      // 7. 监听焦点进入事件
      // this.addEventListener('focusin', (e) => {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   if (e.target && e.target instanceof HTMLElement) {
      //     e.target.blur();
      //   }
      //   document.body.focus();
      // }, { capture: true });
      
      
    } catch (error) {
      console.warn('Failed to disable accordion focus:', error);
    }
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      // this.summary.focus();
      //将焦点设置到body
      document.body.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
